import React from 'react'
import styles from './DropdownItem.module.scss'

function DropdownItem(props) {
    return <div className={styles.item}>{props.children}</div>
}

export default DropdownItem
